<template>
  <div class="leaderboard__wrapper mt-6 my-4x">
    <v-card flat class="grey lighten-4 mx-auto d-flex align-center" width="970" height="250">
      <v-card-text class="text-center text-overline accent--text">MID LEADERBOARD<br>970 x 250</v-card-text>
    </v-card>
  </div>
</template>

<script>
  export default {
    name: 'MidLeaderboard'
  }
</script>